import React from 'react'
import { Container } from 'react-bootstrap'
import { HeaderBar } from './headerBar'
import { PageContent } from './pageContent'
import { useAppContainerContext } from '../appContainer/context'
import { StatusBar } from '../../statusBar'
import { useDiagnosticsContext } from '../contextProviders/diagnosticsContext'
import { Box } from '@mui/joy'

export function DeployableContainer({ children, scrollCallback }) {
  const { isDragging, setIsDragging } = useAppContainerContext()
  const diagnostics = useDiagnosticsContext()

  function endDrag(evt) {
    const toElement = evt.relatedTarget
    if (toElement && document && document.body && document.body.contains(toElement)) {
      return
    }
    evt.stopPropagation()
    evt.preventDefault()
    console.debug('setting isDragging', false)
    setIsDragging(false)
  }

  function handleDrop(evt){
    evt.stopPropagation()
    evt.preventDefault()
    console.debug('setting isDragging', false)
    setIsDragging(false)
  }

  return (
    <Container
      className="root-container"
      onDragOver={(evt) => {
        evt.stopPropagation()
        evt.preventDefault()
        console.debug('setting isDragging', true)
        if (isDragging !== true) setIsDragging(true)
      }}
      onDragEnd={handleDrop}
      onDragLeave={endDrag}
      onDrop={handleDrop}>
      <Box
        component="header"
        className="header-bar">
        <HeaderBar />
      </Box>
      <div className='body-bar'>
        <div className="content-with-navi">
          <PageContent scrollCallback={scrollCallback} >
            {children}
          </PageContent>
        </div>
      </div>
      <Box
        component="footer"
        className="footer-bar">
        <StatusBar
          diagnostics={diagnostics}
        />  
      </Box>
    </Container>
  )
}